import React from 'react';
export function HisAndHers() {
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-359">
      <div className="max-w-[1800px] mx-auto" data-id="element-360">
        <header className="mb-20 text-center" data-id="element-361">
          <span className="text-[10px] font-display uppercase tracking-[0.5em] mb-4 block text-black/40" data-id="element-362">
            Coordinated Style
          </span>
          <h1 className="text-4xl md:text-6xl font-display font-bold tracking-[0.2em] uppercase mb-6" data-id="element-363">
            His & Hers
          </h1>
          <p className="max-w-xl mx-auto text-sm font-light tracking-widest text-black/60 leading-relaxed uppercase" data-id="element-364">
            Matching elegance for couples. Coordinated textiles that tell a
            shared story.
          </p>
        </header>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-365">
          <div className="aspect-[4/5] bg-grey-divider overflow-hidden grayscale hover:grayscale-0 transition-all duration-700" data-id="element-366">
            <img src="https://cdn.magicpatterns.com/uploads/wuY83ouTkEvEoiTmSETLUt/image.png" className="w-full h-full object-cover" alt="His and Hers" data-id="element-367" />
          </div>
          <div className="flex flex-col justify-center space-y-8" data-id="element-368">
            <h2 className="text-2xl font-display font-bold tracking-widest uppercase" data-id="element-369">
              The Union Set
            </h2>
            <p className="text-sm font-light tracking-widest text-black/70 leading-relaxed uppercase" data-id="element-370">
              Hand-woven Kente coordinated for both. A symbol of unity and
              shared heritage.
            </p>
            <button className="bg-black text-white px-10 py-4 text-[10px] font-display uppercase tracking-widest self-start" data-id="element-371">
              Shop the Set
            </button>
          </div>
        </div>
      </div>
    </div>;
}